import React, { Component } from "react";
import Widget from "../../../theme/widgets";

class WidgetPages extends Component {
  render() {
    const {
      location: { state }
    } = this.props;
    const widgets = state && state.widgets;

    return (
      <div>
        {widgets.map((widget, i) => {
          const { path, params, component } = widget;
          return (
            <Widget
              key={i}
              component={component}
              path={path}
              props={{
                extra: {
                  ...state
                },
                ...params
              }}
            />
          );
        })}
      </div>
    );
  }
}

export default WidgetPages;



// WEBPACK FOOTER //
// ./src/components/partials/WidgetPages/index.js